// extracted by mini-css-extract-plugin
export default {"categoryTabs":"CategoryTabs_categoryTabs__6dVaJ","categoryTab":"CategoryTabs_categoryTab__Nb3XO","active":"CategoryTabs_active__noYcy"};